/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const GetSyncCaseItemTagsParams = zod.object({
	filters: zod
		.array(
			zod.object({
				field: zod.string().describe('Field name to filter on'),
				op: zod
					.string()
					.optional()
					.describe('Filter operator (==, !=, <, <=, >, >=, in, ilike, etc.)'),
				value: zod.string().describe('Filter value')
			})
		)
		.optional(),
	order_by: zod.array(zod.string()).optional(),
	order_directions: zod.array(zod.enum(['asc', 'desc'])).optional(),
	limit: zod.number().optional(),
	offset: zod.number().optional()
});

export type GetSyncCaseItemTagsParams = zod.input<typeof GetSyncCaseItemTagsParams>;
export type GetSyncCaseItemTagsParamsOutput = zod.output<typeof GetSyncCaseItemTagsParams>;
